import { FC } from 'react'
import { Box, Flex } from '@/components/atoms/Grid'
import { ArrowIconRightDefault } from '@/components/atoms/icons/ArrowIconRightDefault'
import Link from '@/components/atoms/link'
import { Body3, Small3, Tiny2 } from '@/components/atoms/typography'
import styled from 'styled-components'
import useTranslation from 'next-translate/useTranslation'
import { Blog } from '@/network/graphql.g'
import { DateTime } from 'luxon'
import ResponsiveImage from '@/components/atoms/responsiveImage'

type Post = {
  post: Blog
}

const BlogCard: FC<Post> = ({ post }) => {
  const { t } = useTranslation('common')
  const { mobileImage, title, url } = post
  const createdAt = DateTime.fromISO(post.createdAt).toFormat('dd.MM.yyyy')
  const alternativeImage = (e) => {
    e.target.src = 'https://i.factcool.com/summer/landing-page-summer_11.jpg'
  }

  return (
    <Link href={url}>
      <CardContainer>
        <ImageWrapper>
          <ResponsiveImage
            imageUrl={mobileImage}
            alt="Fashion Blog"
            width={320}
            height={160}
            objectFit="cover"
            onError={alternativeImage}
          />
          <DateBox>
            <StyledTiny2>{createdAt}</StyledTiny2>
          </DateBox>
        </ImageWrapper>
        <Flex
          width="90%"
          height="100%"
          alignItems="center"
          textAlign="center"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box>
            <Body3 mt="20px" mb="4px">
              {title}
            </Body3>
          </Box>
          <StyledBox>
            <Small3>{t('Blog.viewArticleButton')}</Small3>
            <ArrowIconRightDefault />
          </StyledBox>
        </Flex>
      </CardContainer>
    </Link>
  )
}

export default BlogCard

const CardContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
`

const ImageWrapper = styled(Box)`
  position: relative;
  width: 100%;
`

const DateBox = styled(Box)`
  position: absolute;
  box-sizing: border-box;
  width: 86px;
  padding: 2px 6px;
  text-align: center;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.onBackground};
  left: 50%;
  top: 100%;
  transform: translate(-50%, -50%);
`

const StyledTiny2 = styled(Tiny2)`
  font-weight: normal;
  margin: 0;
  line-height: 1;
`

const StyledBox = styled(Box)`
  padding: 2px 20px;
  width: 150px;
  color: ${(props) => props.theme.colors.accent};
  display: flex;
  gap: 6px;
  justify-content: center;
`
